import React from 'react'
import { ModalActionsProps } from '../types'

const ModalActions: React.FC <ModalActionsProps> = ({ children }) => {
    return <div className = "modalBoxMainActionsContainer">{children}</div>
}

export default ModalActions